// extracted by mini-css-extract-plugin
export default {"link":"uD-z","disabled":"vD-z"};